import React, { useRef, useState } from "react";
import type { Swiper as SwiperType } from "swiper";
import { MobileConfiguratorMainContent } from "./MobileConfiguratorMainContent";
import { MobileConfiguratorProgressBar } from "./MobileConfiguratorProgressBar";
import { MobileConfiguratorProgressBarBottom } from "./MobileConfiguratorProgressBarBottom";

const MobileConfiguratorLayout: React.FC = () => {
  const swiperRef = useRef<SwiperType>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  return (
    <>
      {/* Progress bar */}
      <MobileConfiguratorProgressBar
        ref={swiperRef}
        activeIndex={activeIndex}
      />

      {/* Main content */}
      <MobileConfiguratorMainContent
        ref={swiperRef}
        activeIndex={activeIndex}
        setActiveIndex={setActiveIndex}
      />

      <MobileConfiguratorProgressBarBottom
        activeIndex={activeIndex}
        ref={swiperRef}
      />
    </>
  );
};

export default MobileConfiguratorLayout;
